var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { EnvironmentService, HttpMethodType, CaseFormatter } from "../../common";
import { DEFAULT_LANGUAGE } from '../constants';
export class VehicleMetaDataService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    static getInstance() {
        if (VehicleMetaDataService.INSTANCE == null) {
            VehicleMetaDataService.INSTANCE = new VehicleMetaDataService();
        }
        return VehicleMetaDataService.INSTANCE;
    }
    /**
     * Method to retrieve Vehicle MetaData information
     * @param vehicle IVehicle
     * @param language string
     * @returns
     */
    getVehicleMetaData(vehicle, language = DEFAULT_LANGUAGE) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = VehicleMetaDataService.getVehicleMetaDataUrl(vehicle);
            let queryString = `?language=${language}`;
            if (vehicle.vid) {
                queryString += `&vid=${vehicle.vid}`;
            }
            let response = yield this.fetchWrapper(new Request(url + queryString, VehicleMetaDataService.generateRequestInit(HttpMethodType.GET)));
            return yield CaseFormatter.pascalToCamelCase(yield response.json());
        });
    }
    static generateRequestInit(httpMethod, body) {
        return {
            method: httpMethod,
            body: body
        };
    }
    static getVehicleMetaDataUrl(vehicle) {
        return `${EnvironmentService.getEnvironment().partsSelection + this.PartsSelectionServiceVersion}/vehiclemetadata/${vehicle.serviceBarcode}/make/${vehicle.makeId}/model/${vehicle.modelId}/year/${vehicle.serviceYear}`;
    }
}
VehicleMetaDataService.PartsSelectionServiceVersion = '7';
//# sourceMappingURL=VehicleMetaDataService.js.map